import React, { useEffect, useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "./settings.scss";
import { setColor, themeColors } from "../../Utils/theme/handleTheme";
import SettingItem from "./SettingItem";

import { DataManager } from "../../Utils/DataManager";
import { Utilities } from "../../Core/Utilities";
import TimesafeLogin, { ITimesafeLoginStatus } from "../../api/apiTimesafeLogin";

function Settings() {
    const [selectedThemeColor, setSelectedThemeColor] = useState<string>(localStorage.getItem("theme-color") || "");
    const [version, setVersion] = useState<string>(localStorage.getItem("version") || "1");
    // The TimeSafe login is only sent to thanos26 (stored encrypted there), never kept in the browser
    const [timesafeStatus, setTimesafeStatus] = useState<ITimesafeLoginStatus | null>(null);
    const [timesafeUser, setTimesafeUser] = useState<string>("");
    const [timesafePw, setTimesafePw] = useState<string>("");
    const [timesafePwVisible, setTimesafePwVisible] = useState<boolean>(false);
    const [timesafeBusy, setTimesafeBusy] = useState<boolean>(false);

    useEffect(() => {
        TimesafeLogin.getTimesafeLogin()
            .then((status) => {
                setTimesafeStatus(status);
                setTimesafeUser(status.benutzername ?? "");
            })
            .catch((e: any) => {
                setTimesafeStatus(null);
                Utilities.printError(e?.message || "TimeSafe-Login konnte nicht geladen werden");
            });
    }, []);

    const saveTimesafeLogin = async () => {
        if (!timesafeUser.trim() || !timesafePw) {
            Utilities.printError("Bitte TimeSafe-Benutzername und -Passwort eingeben");
            return;
        }
        setTimesafeBusy(true);
        try {
            setTimesafeStatus(await TimesafeLogin.saveTimesafeLogin(timesafeUser.trim(), timesafePw));
            Utilities.printSuccess("TimeSafe-Login gespeichert");
        } catch (e: any) {
            Utilities.printError(e?.message || "TimeSafe-Login konnte nicht gespeichert werden");
        } finally {
            setTimesafePw("");
            setTimesafeBusy(false);
        }
    };

    const deleteTimesafeLogin = async () => {
        setTimesafeBusy(true);
        try {
            await TimesafeLogin.deleteTimesafeLogin();
            setTimesafeStatus({ benutzername: null, hinterlegt: false, geaendert: null });
            setTimesafeUser("");
            Utilities.printSuccess("TimeSafe-Login entfernt");
        } catch (e: any) {
            Utilities.printError(e?.message || "TimeSafe-Login konnte nicht entfernt werden");
        } finally {
            setTimesafePw("");
            setTimesafeBusy(false);
        }
    };
    /*
    const newSettingString = {
        Key: "KEY",
        Name: "SETTING",
        Type: "TEST",
        Data: JSON.parse("[]")
    };
*/
    //const [newSetting, setNewSetting] = useState<string>(JSON.stringify(newSettingString, undefined, 4));

    function changeColor(_color: string) {
        setSelectedThemeColor(_color);
        localStorage.setItem("theme-color", _color);
        setColor(_color);
    }

    const saveSettings = async () => {
        localStorage.setItem("version", version);

        // The TimeSafe login is only sent to thanos26 when a password was entered
        if (timesafePw) {
            await saveTimesafeLogin();
        } else {
            Utilities.printSuccess("Einstellungen gespeichert");
        }
    };

    /*
    function handleNewSetting() {
        const _newSetting = JSON.parse(newSetting);
        _newSetting.Data = JSON.stringify(_newSetting.Data);
        API.Settings.settSetting(_newSetting.Key, _newSetting);
    }
    */

    function handleThemeColorChange(event: React.FormEvent<HTMLSelectElement>) {
        changeColor(event.currentTarget.value);
    }

    let themeColorList = themeColors.map((theme) => (
        <option key={theme.key} value={theme.key}>
            {theme.color}
        </option>
    ));

    const settingsObject = DataManager.GetAllEntries();
    let SettingList = Object.keys(settingsObject).map((key) => (
        <SettingItem key={settingsObject[key].Key} setting={settingsObject[key]}></SettingItem>
    ));

    

    SettingList = [];
    return (
        <div className="list settings">
            <div className="list-item">
                <div className="item-title">THEME COLOR</div>
                <select
                    className="item-content"
                    onChange={(event) => handleThemeColorChange(event)}
                    value={selectedThemeColor}>
                    {themeColorList}
                </select>
            </div>

            <div className="input">
                <div className="item-title">Version</div>
                <input
                        autoComplete="off"
                        type="text"
                        name="version"
                        value={version}
                        onChange={(e) =>
                            setVersion(e.target.value)
                        }
                    />
            </div>

            

            <div className="input">
                <div className="item-title">Timesafe Login</div>
                <div>
                    {timesafeStatus?.hinterlegt
                        ? `hinterlegt für ${timesafeStatus.benutzername}`
                        : "kein TimeSafe-Login hinterlegt"}
                </div>
            </div>

            <div className="input">
                <div className="item-title">Timesafe Name</div>
                <input
                        autoComplete="username"
                        type="text"
                        name="Timesafe User"
                        value={timesafeUser}
                        onChange={(e) =>
                            setTimesafeUser(e.target.value)
                        }
                    />
            </div>

            <div className="input">
                <div className="item-title">Timesafe Password</div>
                <input
                        autoComplete="new-password"
                        type={timesafePwVisible ? "text" : "password"}
                        name="Timesafe password"
                        value={timesafePw}
                        onChange={(e) =>
                            setTimesafePw(e.target.value)
                        }
                    />
                <button
                        type="button"
                        title={timesafePwVisible ? "Passwort ausblenden" : "Passwort anzeigen"}
                        onClick={() => setTimesafePwVisible(!timesafePwVisible)}>
                    {timesafePwVisible ? <FaEyeSlash /> : <FaEye />}
                </button>
            </div>

            <div className="button button__save">
                        <button disabled={timesafeBusy} onClick={() => saveSettings()}>save</button>
            </div>

            {timesafeStatus?.hinterlegt && (
                <div className="button button__save">
                        <button disabled={timesafeBusy} onClick={() => deleteTimesafeLogin()}>remove timesafe login</button>
                </div>
            )}

            {SettingList}
            {/*
            <div className="list-item">
                <div className="item-title">NEW SETTING</div>

                <textarea
                    className="item-content"
                    value={newSetting}
                    onChange={(e) => setNewSetting(e.target.value)}></textarea>
                <button onClick={() => handleNewSetting()}>SAVE</button>
            </div>
            */}
        </div>
    );
}
export default Settings;
